
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useI18n } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/motion";

export const FAQ = () => {
  const { t } = useI18n();

  return (
    <section id="faq" className="app-section scroll-mt-20 border-t border-border/40 bg-card/30">
      <div className="app-container grid gap-10 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-16">
        <Reveal>
          <span className="section-kicker">{t.faq.kicker}</span>
          <h2 className="section-title">{t.faq.title}</h2>
          <p className="section-copy">{t.faq.copy}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="app-card divide-y divide-border/60 px-5 hover:translate-y-0 sm:px-6">
            {t.faq.items.map((item, index) => (
              <AccordionItem key={item.q} value={`faq-${index}`} className="border-b-0">
                <AccordionTrigger className="py-4 text-left font-display text-base font-semibold text-foreground hover:text-highlight hover:no-underline sm:text-lg [&>svg]:shrink-0 [&>svg]:text-primary">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-6 text-muted-foreground sm:text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
